import { createPath } from 'react-router-dom';
import { ReactRouterService } from '../../../core/services/react-router.service';
import { AUTH_ACC_CREATED_QUERY_FLAG } from '../constants/constants';
import { AUTH_ERROR_MESSAGE_PARAM_NAME } from '../../auth-select/constants';
import { ConnectorAuthTypeEnum } from '../interfaces/authType';
import { AuthorisedAccount, ServiceAccount } from '../interfaces/auth';

export function getAddAccountSuccessRedirectionPath(router: ReactRouterService) {
  const searchParams = router.getQueryParams();

  searchParams.delete(AUTH_ERROR_MESSAGE_PARAM_NAME);
  searchParams.set(AUTH_ACC_CREATED_QUERY_FLAG, 'true');

  return window.location.origin + createPath({
    pathname: router.pathname,
    search: searchParams.toString(),
    hash: router.hash
  });
}

export function removeUrlQueryParam(router: ReactRouterService, queryParamKey: string) {
  const searchParams = router.getQueryParams();

  searchParams.delete(queryParamKey);

  return createPath({
    pathname: router.pathname,
    search: searchParams.toString(),
    hash: router.hash
  });
}

export function authorizedAccountsFactory(rawData: any[], authType: ConnectorAuthTypeEnum): (ServiceAccount | AuthorisedAccount)[] {
  if (!rawData || rawData.length === 0) {
    return [];
  }

  return rawData.map((account) => {
    if (authType === ConnectorAuthTypeEnum.OAUTH) {
      return new AuthorisedAccount(account);
    } else {
      return new ServiceAccount(account);
    }
  });
}

export function fetchErrorMessageAndRedirect(router: ReactRouterService) {
  let redirectedErrorMessage: string;

  const queryParams = router.getQueryParams();

  if (queryParams.has(AUTH_ERROR_MESSAGE_PARAM_NAME)) {
    const encodedErrorMessage = queryParams.get(AUTH_ERROR_MESSAGE_PARAM_NAME);

    redirectedErrorMessage = window.atob(encodedErrorMessage);
    const url = removeUrlQueryParam(router, AUTH_ERROR_MESSAGE_PARAM_NAME);

    router.navigate(
      url,
      { replace: true }
    );
  }

  return redirectedErrorMessage;
}

export function removeParamAndFetchUrl(router: ReactRouterService, param: string) {
  return window.location.origin + removeUrlQueryParam(router, param);
}
